module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAIAAAC2BqGFAAABNklEQVR42uzcMU6DYBiAYYHfYIhx4gIOegQ9gImzp/AQrk6cw7gaL9C1e4feom2akoZAQtKdpe1QCOV5x3/oV56QjwlC/PF7o8sXIwANWqBBgxZo0AINGrRAgxZo0KAFGrRAgwYt0KAFGjRogQYt0KBBC/SVFIYaPPt+e3nKex662tWPn//Tgs7SkKVJz0Pv74LVYUcLtIfh8bb7ZlM2Z/zRJHrIbjuHVdNWdXv6j6zLeqjrjcby+tvrcz4v3juHXz+L4m9pdQg0aNACDVqgQYMWaNACDRq0QIMWaNCgBRq0QIMGLdCgBRo0aIEGLdCgQQs0aIEGDVqgQQs0aNACDVrj+YyEO1qgQYMWaNACDRq0QIMWaNCgBRq0QIMGLdCgBRo0aIEGLdCgQQs0aIEGPakOAQAA///4Rh6wtHz92AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/the-hill.png
// module id = UYmS
// module chunks = 0